<template>
  <div>
    <b-spinner
      v-if="loading"
      medium
      class="ml-2"
    />

    <div
      v-else
      class="attachments-grid"
    >
      <div
        v-for="view in ['top', 'side']"
        :key="view"
      >
        <div
          v-for="img in current[view]"
          :key="img.uuid"
          class="image-wrapper"
          @click="openOverlay(img)"
        >
          <img
            :src="img.url"
            :alt="img.description"
          >
          <span class="view-label">{{ $t(`attachments.${view}`) }}</span>
        </div>
      </div>
    </div>

    <LightboxOverlay
      v-if="overlay.visible"
      :overlay-item="overlay.item"
      :visible="overlay.visible"
      :total-items="lightboxImages.length"
      @closeSilentboxOverlay="overlay.visible = false"
      @requestNextSilentBoxItem="showNextItem"
      @requestPreviousSilentBoxItem="showPreviousItem"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getFileByUUID } from '@/../shared/API/images'
import LightboxOverlay from '@/components/common/lightbox/LightboxOverlay.vue'

export default {
  name: 'ChargingpointAttachments',

  components: { LightboxOverlay },

  props: {
    chargingpoint: { type: Object, required: true },
  },

  data() {
    return {
      galleryImages: { top: [], side: [] },
      current: { top: [], side: [] },
      loading: false,
      overlay: {
        visible: false,
        item: {},
        currentItem: 0,
      },
    }
  },

  computed: {
    ...mapGetters('config', ['participationConfig']),
    lightboxImages() {
      return ['top', 'side'].flatMap(view =>
        this.current[view].map(img => ({
          src: img.url,
          alt: img.description,
          description: img.description,
        })),
      )
    },
  },

  async created() {
    await this.fetchAttachments()
  },

  methods: {
    openOverlay(img) {
      const index = this.lightboxImages.findIndex(i => i.src === img.url)
      this.overlay.item = this.lightboxImages[index] || { src: img.url, description: img.description }
      this.overlay.currentItem = index
      this.overlay.visible = true
    },
    showNextItem() {
      let next = this.overlay.currentItem + 1
      if (next >= this.lightboxImages.length) next = 0
      this.overlay.item = this.lightboxImages[next]
      this.overlay.currentItem = next
    },
    showPreviousItem() {
      let prev = this.overlay.currentItem - 1
      if (prev < 0) prev = this.lightboxImages.length - 1
      this.overlay.item = this.lightboxImages[prev]
      this.overlay.currentItem = prev
    },
    async fetchAttachments() {
      if (!this.chargingpoint.images) return
      for (const view of ['top', 'side']) {
        await this.loadingImages(view, this.chargingpoint.images[view])
      }
    },

    async loadingImages(view, images) {
      if (!images?.length) return

      try {
        this.loading = true

        const primaryImage = images.find((img) => img.primary)
        if (!primaryImage) {
          this.galleryImages[view] = []
          this.current[view] = []
          return
        }

        const imageWithUrl = {
          ...primaryImage,
          url: await getFileByUUID(primaryImage.endpoint, primaryImage.index),
          description: `${view} view #${primaryImage.index ?? ''}`,
        }

        this.galleryImages[view] = [imageWithUrl]
        this.current[view] = [imageWithUrl]
      } catch (err) {
        console.error(`Error loading ${view} images`, err)
        this.galleryImages[view] = []
        this.current[view] = []
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.attachments-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  .image-wrapper {
  position: relative;
  width: 100%;
  padding-top: 100%;
  border-radius: 6px;
  border: 2px solid transparent;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;

  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s;
  }

  > .view-label {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
    padding: 4px 0;
    font-weight: 500;
    text-transform: capitalize;
    font-size: 0.9rem;
  }
}


}
</style>
